import { ListAllSurveysQuery, ListAllSurveysQueryVariables } from '@/graphql/generated/graphql';
import { FETCH_SURVEYS } from '@/graphql/queries/survey/survey-dashboard';
import { useQuery } from '@apollo/client';
import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from '@heroicons/react/24/outline';
import { useSurveyDashboardStore } from '../store/useSurveyDashboard.store';
import { useEffect, useState } from 'react';

export const SurveysNavigation = () => {
  const { data } = useQuery<ListAllSurveysQuery, ListAllSurveysQueryVariables>(FETCH_SURVEYS, {
    fetchPolicy: 'cache-first',
  });

  const { updateCurrentSurvey } = useSurveyDashboardStore();
  const surveys = data?.surveysByUser || [];
  const [currentIndex, setCurrentSurveyIndex] = useState(0);

  const navigatePrevious = () => {
    if (currentIndex > 0) {
      setCurrentSurveyIndex(currentIndex - 1);
      updateCurrentSurvey(surveys[currentIndex - 1]);
    }
  };

  const navigateNext = () => {
    if (currentIndex < surveys.length - 1) {
      setCurrentSurveyIndex(currentIndex + 1);
      updateCurrentSurvey(surveys[currentIndex + 1]);
    }
  };

  const currentSurvey = surveys[currentIndex];

  // Update store when surveys are loaded
  useEffect(() => {
    if (surveys.length > 0) {
      updateCurrentSurvey(surveys[currentIndex]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveys]);

  return (
    <>
      <ArrowLeftCircleIcon
        className={`h-6 w-6 cursor-pointer ${
          currentIndex > 0 ? 'text-black-600 hover:text-primary-500' : 'cursor-not-allowed text-gray-300'
        }`}
        onClick={navigatePrevious}
      />
      <h1 className="text-sh-md font-bold">{currentSurvey?.name || 'No Survey'}</h1>
      <ArrowRightCircleIcon
        className={`h-6 w-6 cursor-pointer ${
          currentIndex < surveys.length - 1
            ? 'text-black-600 hover:text-primary-500'
            : 'cursor-not-allowed text-gray-300'
        }`}
        onClick={navigateNext}
      />
    </>
  );
};
